module.exports = __webpack_public_path__ + "img/product-center-normaecloud.e906f7ea.png";